import { Flex, Pane, Text } from '@leverege/ui-elements'
import { formatPaceTimes } from '../Utils'
import S from './PaceOverviewCards.css'
import usePaceOverviewCards from './hooks/usePaceOverviewCards'

function PaceOverviewCards( { fgJob } ) {
  const {
    paces : { ss, ps, bnd },
  } = usePaceOverviewCards( fgJob )
  const paces = [ ss, ps, bnd ]

  return (
    <Flex gap={10} variant="col">
      {paces.map( p => (
        <Pane
          variant="mobilePaceCard"
          className={S.card}
          style={{ display : p.display }}>
          <Pane variant="mobilePaceCardHeader">
            <Flex variant="rowSpaceBetween" align="center">
              <Text variant="mobilePaceCardBigHeader">{p.title}</Text>
              {p.completed && (
                <Text variant={`mobileTag${p.status}`}>Completed</Text>
              )}
            </Flex>
          </Pane>
          <Pane
            variant="mobilePaceCardArea"
            style={{ backgroundColor : 'white' }}>
            <Flex variant="rowSpaceBetween" style={{ flexGrow : 1 }} gap={14}>
              <Flex variant="colM" style={{ flex : 1 }}>
                <Text variant="factoryPaceCardDetailHeader">CT</Text>
                <Text variant={`mobileSmallPace${p?.status}`}>
                  {p.currentPace}
                </Text>
              </Flex>
              <Flex variant="colM" style={{ flex : 1 }}>
                <Text variant="factoryPaceCardDetailHeader">Target CT</Text>
                <Text
                  variant="factoryPaceCardDetailContent"
                  style={{ fontSize : 20 }}>
                  {p.targetPace}
                </Text>
              </Flex>
              <Flex variant="colM" style={{ flex : 1 }}>
                <Text variant="factoryPaceCardDetailHeader">
                  CT Difference
                </Text>
                <Text
                  variant="factoryPaceCardDetailContent"
                  style={{ fontSize : 20 }}
                  className={S[`factoryPaceCardDetailContent${p.status}`]}>
                  {p.status === 'Idle' ?
                    '-' :
                    formatPaceTimes( p.currentPace - p.targetPace, {
                      signDisplay : 'always',
                    } )}
                </Text>
              </Flex>
            </Flex>
          </Pane>
        </Pane>
      )
      )}
    </Flex>
  )
}

export default PaceOverviewCards
